export const ADDFORMDATA = "form/adding";
export const DELETESINGLEROW = "form/delete";
